import React from 'react';
import SimpleLabelInfoBox from '../Common/SimpleLabelInfoBox';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import PRODUCT_TYPES from '../../constants/productTypes';

const ProductSubDescription = ({ productDetailData }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={'product-sub-top-info-wrapper'}>
        <div className='sub-top-info-title-group'>
          <h2 className={'sub-top-info-title'}>{productDetailData?.title}</h2>
        </div>
        <div className='sub-top-info-price-group'>
          <div className='sub-top-info-money-group'>
            <p className={'money-info'}>
              {productDetailData?.price?.toLocaleString()}
              &nbsp;{productDetailData?.currency}
              {productDetailData?.product_type === PRODUCT_TYPES.DIGITAL ? '~' : null}
            </p>
          </div>
          <div className='sub-top-info-point-group'>
            <span className={'star-point-group'}>
              <i className={'icon icon-star-point'} />
            </span>
            <span className={'star-point-info'}>
              {productDetailData?.price_starbeat?.toLocaleString()}
              {productDetailData?.product_type === PRODUCT_TYPES.DIGITAL ? '~' : null}
            </span>
          </div>
        </div>
      </div>
      <div
        className={`product-label-info-wrapper ${
          productDetailData?.product_type === PRODUCT_TYPES.VIDEO ? 'type-video' : ''
        }`}
      >
        {productDetailData?.product_type === PRODUCT_TYPES.VIDEO ? (
          <>
            <SimpleLabelInfoBox
              label={t('event_date')}
              info={dayjs(productDetailData?.performance_start_at).format('YYYY. MM. DD HH:mm')}
            />
            <SimpleLabelInfoBox
              label={t('event_length')}
              info={`${productDetailData?.performance_time} ${t('minutes')}`}
            />
            <SimpleLabelInfoBox label={t('product_contents')} info={productDetailData?.product_contents} />
          </>
        ) : null}
        <SimpleLabelInfoBox
          label={t('purchase_benefits')}
          info={`${
            productDetailData?.product_type === PRODUCT_TYPES.DIGITAL ? t('minimum_label') : ''
          } ${productDetailData?.benefit_amount?.toLocaleString()} ${t('earn_star_beats')}`}
        />
      </div>
    </>
  );
};

export default ProductSubDescription;
